import React from 'react'
import { SecurityQuestions } from './SecurityQuestions'
import { useLoginAndSaveSecurityQuestionsMutation } from './SecurityQuestions.codegen'
import { observer } from 'mobx-react'
import { useLoginContext } from '../login/LoginContext'

const useLoginToExistingAccountWithPassword = () => {
  const ctx = useLoginContext()
  const [fetch] = useLoginAndSaveSecurityQuestionsMutation()
  return async () => {
    const { data } = await fetch({
      variables: {
        password: ctx.password,
        accountNameOrEmail: ctx.userIdentity,
        additionalData: ctx.pickUserAdditionalData(),
        questionAnswers: ctx.securityQuestions
      }
    })
    if (data?.loginAndSaveSecurityQuestions) {
      return data.loginAndSaveSecurityQuestions
    }
    return null
  }
}

export const SetSecurityQuestionsAndLoginStep: React.FC = observer(() => {
  const loginToExistingAccountWithPassword =
    useLoginToExistingAccountWithPassword()

  const submit = async () => !!(await loginToExistingAccountWithPassword())

  return <SecurityQuestions submit={submit} />
})

SetSecurityQuestionsAndLoginStep.displayName =
  'SetSecurityQuestionsAndLoginStep'
